module.exports = __webpack_public_path__ + "img/quick-information-on-council-bluffs-chiropractors-in-2022.8b78bb2e.jpg";